/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatMessageSendingJobStatus =
  | 'ChatMessageSendingJobStatusCompleted'
  | 'ChatMessageSendingJobStatusFailed'
  | 'ChatMessageSendingJobStatusPending'
  | 'ChatMessageSendingJobStatusRunning';

export type DeleteChatMessageSendingJobInput = {
  guid: string | number;
};

export type ChatMessageSendingJobDetailPageDeleteButtonFragment = { chatMessageSendingJob: { guid: string, status: Types.ChatMessageSendingJobStatus } | null };

export type DeleteChatMessageSendingJobMutationVariables = Exact<{
  input: Types.DeleteChatMessageSendingJobInput;
}>;


export type DeleteChatMessageSendingJobMutation = { deleteChatMessageSendingJob:
    | { __typename: 'DeleteChatMessageSendingJobErrorPayload', reason: string }
    | { __typename: 'DeleteChatMessageSendingJobSuccessPayload', jobGuid: string | null }
   };

export const ChatMessageSendingJobDetailPageDeleteButtonFragmentDoc = gql`
    fragment ChatMessageSendingJobDetailPageDeleteButton on Query {
  chatMessageSendingJob(guid: $guid) {
    guid
    status
  }
}
    `;
export const DeleteChatMessageSendingJobDocument = gql`
    mutation deleteChatMessageSendingJob($input: DeleteChatMessageSendingJobInput!) {
  deleteChatMessageSendingJob(input: $input) {
    __typename
    ... on DeleteChatMessageSendingJobSuccessPayload {
      jobGuid
    }
    ... on DeleteChatMessageSendingJobErrorPayload {
      reason
    }
  }
}
    `;

/**
 * __useDeleteChatMessageSendingJobMutation__
 *
 * To run a mutation, you first call `useDeleteChatMessageSendingJobMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMessageSendingJobMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteChatMessageSendingJobMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChatMessageSendingJobMutation(options: VueApolloComposable.UseMutationOptions<DeleteChatMessageSendingJobMutation, DeleteChatMessageSendingJobMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteChatMessageSendingJobMutation, DeleteChatMessageSendingJobMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteChatMessageSendingJobMutation, DeleteChatMessageSendingJobMutationVariables>(DeleteChatMessageSendingJobDocument, options);
}
export type DeleteChatMessageSendingJobMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteChatMessageSendingJobMutation, DeleteChatMessageSendingJobMutationVariables>;